<template>
  <div class="token-body">
    <el-form
      :model="tokenForm"
      :rules="tokenRules"
      ref="ruleForm"
      label-width="100px"
      label-position="top"
      class="token-form"
    >
      <el-form-item>
        <div class="token-title">LP分红<a class="tips" href="https://tokenbox.tools/lpReflection.html" target="_blank">教程</a></div>
        <div class="token-advantages">
          <span>加池参与分红、池子越来越厚，币价螺旋上涨！</span>
        </div>
      </el-form-item>

      <el-form-item label="代币全称:" prop="name">
        <el-input
          v-model="tokenForm.name"
          placeholder="请输入全称"
          clear
        ></el-input>
      </el-form-item>

      <el-form-item label="代币简称:" prop="symbol">
        <el-input
          v-model="tokenForm.symbol"
          placeholder="请输入简称"
          clear
        ></el-input>
      </el-form-item>

      <el-form-item label="发行量:" prop="total">
        <el-input
          v-model.number="tokenForm.total"
          placeholder="请输入数值"
          oninput="value=value.replace(/[^\d]/g,'')"
          clear
        ></el-input>
      </el-form-item>

      <el-form-item label="精度:" prop="decimals">
          <template slot="label" >
          精度
          <el-tooltip class="item" effect="dark" placement="top">
            <div slot="content">
              此处精度为小数点后的位数，通常为18
            </div>
            <i class="el-icon-warning"></i>
          </el-tooltip>
        </template>
        <el-input-number
          v-model="tokenForm.decimals"
          :step="1"
          :min="1"
          :max="18"
          class="token-inputNumber"
        ></el-input-number>
      </el-form-item>

      <el-form-item
        label="分红代币:"
        prop="rewordToken"
        class="form-labelHorizontal"
      >
        <el-select
          v-model="tokenForm.rewordToken"
          placeholder="请选择"
          :popper-append-to-body="false"
          :no-data-text="'暂无数据'"
        >
          <el-option
            v-for="item in tokenForm.currencyOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="买入税率">
        <template slot="label">
          买入税率&nbsp;&nbsp;{{ buyTaxRate }}&nbsp;&nbsp;%
          <el-tooltip class="item" effect="dark" placement="top">
            <div slot="content">
              税率说明<br /><br />
              回流税率: 交易中指定额度的代币将会自动添加到流动池内,
              保证交易始终存在流动性<br /><br />
              营销税率: 交易中指定额度的代币将会自动转入营销钱包中,
              用于项目方做其他营销<br /><br />
              分红税率: 交易中指定额度的代币, 用来购买分红代币,
              并发送给LP持有者<br /><br />
              销毁税率: 交易中指定额度的代币将会被打入黑洞地址,
              变相实现通缩机制<br /><br />
              买入总税率不能超过25%, 交易总税率不能超过50%
            </div>
            <i class="el-icon-warning"></i>
          </el-tooltip>
        </template>
        <div class="token-handlingFees">
          <el-input
            @keyup.native="onlyNumber()"
            placeholder="0.01"
            v-model="tokenForm.buyFundFee"
            style="margin: 0 120px 0 0"
          >
            <template slot="prepend">营销税率:</template>
            <el-button slot="append">%</el-button>
          </el-input>

          <el-input
            @keyup.native="onlyNumber()"
            placeholder="0.01"
            v-model="tokenForm.buyBurnFee"
          >
            <template slot="prepend">销毁税率:</template>
            <el-button slot="append">%</el-button>
          </el-input>
        </div>

        <div class="token-handlingFees">
          <el-input
            @keyup.native="onlyNumber()"
            placeholder="0.01"
            v-model="tokenForm.buyReflectFee"
            style="margin: 0 120px 0 0"
          >
            <template slot="prepend">回流税率:</template>
            <el-button slot="append">%</el-button>
          </el-input>

          <el-input
            @keyup.native="onlyNumber()"
            placeholder="0.01"
            v-model="tokenForm.buyLPFee"
          >
            <template slot="prepend">分红税率:</template>
            <el-button slot="append">%</el-button>
          </el-input>
        </div>

        <!-- <span class="token-mark">百分比设置,总比例不可以大于百分之25%</span> -->
      </el-form-item>

      <el-form-item label="卖出税率">
        <template slot="label">
          卖出税率&nbsp;&nbsp;{{ sellTaxRate }}&nbsp;&nbsp;%
          <el-tooltip class="item" effect="dark" placement="top">
            <div slot="content">
              税率说明<br /><br />
              回流税率: 交易中指定额度的代币将会自动添加到流动池内,
              保证交易始终存在流动性<br /><br />
              营销税率: 交易中指定额度的代币将会自动转入营销钱包中,
              用于项目方做其他营销<br /><br />
              分红税率: 交易中指定额度的代币, 用来购买分红代币,
              并发送给LP持有者<br /><br />
              销毁税率: 交易中指定额度的代币将会被打入黑洞地址,
              变相实现通缩机制<br /><br />
              买入总税率不能超过25%, 交易总税率不能超过50%
            </div>
            <i class="el-icon-warning"></i>
          </el-tooltip>
        </template>
        <div class="token-handlingFees">
          <el-input
            @keyup.native="onlyNumber()"
            placeholder="0.01"
            v-model="tokenForm.sellFundFee"
            style="margin: 0 120px 0 0"
          >
            <template slot="prepend">营销税率:</template>
            <el-button slot="append">%</el-button>
          </el-input>

          <el-input
            @keyup.native="onlyNumber()"
            placeholder="0.01"
            v-model="tokenForm.sellBurnFee"
          >
            <template slot="prepend">销毁税率:</template>
            <el-button slot="append">%</el-button>
          </el-input>
        </div>

        <div class="token-handlingFees">
          <el-input
            @keyup.native="onlyNumber()"
            placeholder="0.01"
            v-model="tokenForm.sellReflectFee"
            style="margin: 0 120px 0 0"
          >
            <template slot="prepend">回流税率:</template>
            <el-button slot="append">%</el-button>
          </el-input>

          <el-input
            @keyup.native="onlyNumber()"
            placeholder="0.01"
            v-model="tokenForm.sellLPFee"
          >
            <template slot="prepend">分红税率:</template>
            <el-button slot="append">%</el-button>
          </el-input>
        </div>

        <!-- <span class="token-mark">百分比设置,总比例不可以大于百分之25%</span> -->
      </el-form-item>

      <el-form-item label="营销地址:" prop="fundAddress">
        <el-input placeholder="请输入地址" v-model="tokenForm.fundAddress">
          <el-button slot="append" @click="setfundAddress()"
            >设置当前地址</el-button
          >
        </el-input>
      </el-form-item>

      <el-form-item
        label="交易平台:"
        prop="swapPlatform"
        class="form-labelHorizontal"
      >
        <el-select
          v-model="tokenForm.swapPlatform"
          placeholder="请选择"
          :popper-append-to-body="false"
          :no-data-text="'暂无数据'"
        >
          <el-option
            v-for="item in tokenForm.swapPlatformOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        label="底池代币:"
        prop="currency"
        class="form-labelHorizontal"
      >
        <el-select
          v-model="tokenForm.currency"
          placeholder="请选择"
          :popper-append-to-body="false"
          :no-data-text="'暂无数据'"
        >
          <el-option
            v-for="item in tokenForm.currencyOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item prop="currencyAddress" v-if="tokenForm.currency == 'default'">
        <el-input
          placeholder="请输入合约地址"
          v-model="tokenForm.currencyAddress"
        >
          <el-button slot="append" icon="el-icon-search">查询</el-button>
        </el-input>

        <!-- <div class="token-alert2">全称：{{ tokenForm.name2 }}</div>
        <div class="token-alert2">简称：{{ tokenForm.symbol2 }}</div>
        <div class="token-alert2">精度：{{ tokenForm.decimals2 }}</div>
        <span class="token-mark"
          >添加流动性时需要添加代币与底池代币之间的交易对,
          否则无法进行正常分红与回流</span
        > -->
      </el-form-item>

      <el-form-item label="手动开启交易" class="form-labelHorizontal">
        <el-switch v-model="tokenForm.enable0ffTrade"></el-switch>
        <span class="token-mark"
          >添加池子后的首次交易需要在控制台手动开启(如关闭,
          则添加流动性后立即可以进行交易), 交易开启后无法关闭</span
        >
      </el-form-item>

      <el-form-item label="杀区块" class="form-labelHorizontal">
        <el-switch v-model="tokenForm.enableKillBlock"></el-switch>
        <span class="token-mark"
          >将对开启交易后在n个区块内交易的地址全部拉入黑名单,
          用于防止机器人抢跑买入, 必须手动开启交易</span
        >
      </el-form-item>

      <el-form-item
        label="区块数量:"
        prop="killBlockNum"
        class="form-labelHorizontal"
        v-if="tokenForm.enableKillBlock"
      >
        <el-input-number
          v-model="tokenForm.kb"
          :step="1"
          :min="1"
          class="token-inputNumber"
        ></el-input-number>
      </el-form-item>

      <el-form-item label="税率开关" class="form-labelHorizontal">
        <el-switch v-model="tokenForm.enableChangeTax"></el-switch>
        <span class="token-mark"
          >可在创建代币后手动调整税率, 买卖税率各不能超过25%,
          此开关关闭后无法再次开启</span
        >
      </el-form-item>

      <el-form-item label="自动空投" class="form-labelHorizontal">
        <el-switch v-model="tokenForm.airdropEnable"></el-switch>
        <span class="token-mark"
          >开启开关后, 用户交易时, 将会自动向随机地址空投小额代币,
          以增加持币地址,单次最多空投5个</span
        >
      </el-form-item>

      <el-form-item
        label="空投数量:"
        prop="autoAirdropNum"
        class="form-labelHorizontal"
        v-if="tokenForm.autoAirdrop"
      >
        <el-input-number
          v-model="tokenForm.airdropNumbs"
          :step="1"
          :min="1"
          class="token-inputNumber"
        ></el-input-number>
      </el-form-item>

      <el-form-item label="黑名单功能" class="form-labelHorizontal">
        <el-switch v-model="tokenForm.enableRewardList"></el-switch>
        <span class="token-mark"
          >可拉黑部分钱包地址令其无法交易, 此开关关闭后无法再次开启</span
        >
      </el-form-item>

      <el-form-item label="最大持币量" class="form-labelHorizontal">
        <el-switch v-model="tokenForm.enableWalletLimit"></el-switch>
        <span class="token-mark"
          >可设置单个钱包持有的最大代币数量, 此开关关闭后无法再次开启</span
        >
      </el-form-item>

      <el-form-item v-if="tokenForm.enableWalletLimit">
        <el-input
          v-model="tokenForm.maxWalletAmount"
          placeholder="请输入最大持币量"
          oninput="value=value.replace(/[^\d]/g,'')"
          clear
        ></el-input>
      </el-form-item>

      <!-- 选填内容 -->
      <el-form-item class="token-optionalContent">
        <template slot="label">
          选填内容
          <el-tooltip class="item" effect="dark" placement="top">
            <div slot="content">
              选填内容<br /><br />
              ①&nbsp;官网链接<br /><br />
              ②&nbsp;telegram群组<br /><br />
              ③&nbsp;twitter<br /><br />
              ④&nbsp;Discord<br /><br />
              ⑤&nbsp;简介
            </div>
            <i class="el-icon-warning"></i>
          </el-tooltip>
          <span
            class="optionalContent-btn"
            @click="optionalContent = true"
            v-if="!optionalContent"
            >展开</span
          >
          <span
            class="optionalContent-btn"
            @click="optionalContent = false"
            v-else
            >收起</span
          >
        </template>
      </el-form-item>

      <el-form-item
        label="官网链接:"
        prop="officialWebsiteLink"
        v-if="optionalContent"
      >
        <el-input
          v-model="tokenForm.officialWebsiteLink"
          placeholder="选填,"
          clear
        ></el-input>
      </el-form-item>

      <el-form-item
        label="telegram群组:"
        prop="telegram"
        v-if="optionalContent"
      >
        <el-input
          v-model="tokenForm.telegram"
          placeholder="选填,"
          clear
        ></el-input>
      </el-form-item>

      <el-form-item label="twitter:" prop="twitter" v-if="optionalContent">
        <el-input
          v-model="tokenForm.twitter"
          placeholder="选填,"
          clear
        ></el-input>
      </el-form-item>

      <el-form-item label="Discord:" prop="discord" v-if="optionalContent">
        <el-input
          v-model="tokenForm.discord"
          placeholder="选填,"
          clear
        ></el-input>
      </el-form-item>

      <el-form-item label="简介:" prop="introduction" v-if="optionalContent">
        <el-input
          v-model="tokenForm.introduction"
          placeholder="选填,简介最多200字"
          type="textarea"
          maxlength="200"
          show-word-limit
          rows="5"
          clear
        ></el-input>
      </el-form-item>

      <el-form-item>
        <div v-if="gasConfig && gasConfig.price > 0" class="token-cost">
          费用：{{ gasConfig.price }} {{ gasConfig.units }}
        </div>
      </el-form-item>

      <el-form-item>
        <div @click="submitForm('ruleForm')" class="token-createBtn">
          创建合约
        </div>
      </el-form-item>

      <el-form-item>
        <div class="token-alert">
          本工具只用于区块链学习测试，如用于违法活动，与本站无关
        </div>
      </el-form-item>
    </el-form>
    <DeployAlert
      :visible.sync="showDeploy"
      :tokenForm="tokenForm"
      :contractData="contractData"
      :deployData="deployData"
    ></DeployAlert>
    <LoadingAlert
      :visible.sync="showLoading"
      :LoadingText="loadingText"
    ></LoadingAlert>
    <NodeAlert :visible.sync="showNode" mode="lpDividend"></NodeAlert>
  </div>
</template>

<script>
import NodeAlert from "@/components/alert/nodeAlert";
import DeployAlert from "@/components/alert/deployAlert";
import LoadingAlert from "@/components/alert/loading";
import { getPredictContractAddr, sendTransaction } from "@/config/wallet.js";
import {
  compilerContract,
  saveContractRecord,
  updateContractRecord,
  consoleDetail,
} from "@/config/api.js";
export default {
  components: {
    DeployAlert,
    LoadingAlert,
    NodeAlert,
  },
  data() {
    return {
       showNode: false,
      tokenForm: {
        name: "Test Coin",
        symbol: "TEST",
        total: 10000,
        decimals: 18,
        enable0ffTrade: false,
        enableRewardList: false,
        rewordToken: null,
        enableKillBlock: false,
        kb: null,
        currencyIsEth: false,
        enableChangeTax: false,
        enableWalletLimit: false,
        maxWalletAmount: null,
        airdropEnable: false,
        airdropNumbs: null,

        name2: "",
        symbol2: "",
        decimals2: "",

        swapPlatform: "",
        swapPlatformOptions: [],
        fundAddress: "",
        NFTContract: "",

        buyFundFee: null,
        buyBurnFee: null,
        buyReflectFee: null,
        buyLPFee: null,

        sellFundFee: null,
        sellBurnFee: null,
        sellReflectFee: null,
        sellLPFee: null,

        currency: null,
        currencyOptions: [],
        currencyAddress: "",

        buyResult: 0,
        sellResult: 0,

        officialWebsiteLink: "",
        telegram: "",
        twitter: "",
        discord: "",
        introduction: "",
      },
      tokenRules: {
        name: [{ required: true, message: "请输入全称", trigger: "change" }],
        symbol: [{ required: true, message: "请输入简称", trigger: "change" }],
        total: [{ required: true, message: "请输入数值", trigger: "change" }],
        fundAddress: [
          { required: true, message: "请输入地址", trigger: "change" },
        ],
        NFTContract: [
          { required: true, message: "请输入地址", trigger: "change" },
        ],
        currency: [
          { required: true, message: "请选择底池代币", trigger: "change" },
        ],
        swapPlatform: [
          { required: true, message: "请选择交易平台", trigger: "change" },
        ],
        rewordToken: [
          { required: true, message: "请选择分红代币", trigger: "change" },
        ],
      },
      account: localStorage.getItem("TokenBox-account"),
      contractData: { contractCode: "lpDividend" },
      optionalContent: false,
      showDeploy: false,
      gasConfig: this.$getGasConfig("lpDividend"),
      contractConfig: this.$getChainConfig(),
      showLoading: false,
      deployData: [],
      loadingText: null,
    };
  },
  async beforeMount() {
    if (!this.contractConfig.support.includes("lpDividend")) {
      this.showNode = true;
    }
    if (this.contractConfig) {
      console.log(this.contractConfig);
      this.tokenForm.swapPlatformOptions = this.contractConfig.swap;
      this.tokenForm.currencyOptions = this.contractConfig.currency;
    }
    if (this.$route.query.contractId && this.$route.query.hash) {
      this.contractData.contractId = this.$route.query.contractId;
      var res = await consoleDetail({
        contractId: this.$route.query.contractId,
      });
      if (res && res.data) {
        this.tokenForm = JSON.parse(res.data.content);
      }
      this.payContractGas();
    }
  },
  methods: {
    //提交数据
    submitForm(formName) {
      var account = localStorage.getItem("TokenBox-account");
      if (!account || account.length == 0) {
        this.showLoading = false;
        this.$message({
          message: "请先连接钱包",
          type: "warning",
        });
        return;
      }
      console.log("gasConfig=", this.gasConfig, this.contractConfig);
      if (!this.gasConfig || !this.contractConfig) {
        this.$message({
          message: "暂不支持该链",
          type: "warning",
        });
        return;
      }
      this.$refs[formName].validate((valid) => {
        console.log("form=", this.tokenForm);
        if (this.tokenForm.buyResult > 25) {
          this.$message({
            message: "买入百分比设置,总比例不可以大于百分之25%",
            type: "warning",
          });
          return;
        }

        if (this.tokenForm.sellResult > 25) {
          this.$message({
            message: "卖出百分比设置,总比例不可以大于百分之25%",
            type: "warning",
          });
          return;
        }
        if (valid) {
          this.payContractGas();
          return;
        } else {
          this.$message({
            message: "请输入完整",
            type: "warning",
          });
          return false;
        }
      });
    },
    async payContractGas() {
      //支付服务费
      this.showLoading = true;
      var res = null;
      var param = null;
      if (this.$route.query.contractId && this.$route.query.hash) {
        param = { transactionHash: this.$route.query.hash };
      }
      if (!param) {
        this.loadingText = "正在请求钱包交易";
        try {
          var tx = await sendTransaction(
            this.account,
            this.gasConfig.collectionAddress,
            this.gasConfig.price
          );
          this.loadingText = "交易已提交，等待区块确认";
          res = await tx.wait();
          console.log("交易已完成=", res);
        } catch (error) {
          this.showLoading = false;
          this.$showErrorMessage(error);
          return
        }
      } else {
        res = param;
      }
      console.log("sendTransaction=", res);

      //编译合约，从server端获取合约abi以及code
      var data = {
        contractCode: this.contractData.contractCode,
        argument: {
          name: this.tokenForm.symbol,
          website: this.tokenForm.symbol,
          telegram: this.tokenForm.telegram,
          twitter: this.tokenForm.twitter,
          discord: this.tokenForm.discord,
          description: this.tokenForm.introduction,
        },
        chainId: localStorage.getItem("TokenBox-chainID"),
        hash: res.transactionHash,
      };
      console.log(data);
      var res2 = await compilerContract(JSON.stringify(data));
      console.log("compilerContract=", JSON.parse(res2.data.abi));
      if (res2 && res2.code == 200200) {
        this.contractData.abi = res2.data.abi;
        this.contractData.bin = res2.data.bin;
        this.contractData.content = res2.data.content;
        this.contractData.contractAddr = await getPredictContractAddr(
          this.account
        );
        this.saveRecord(res.transactionHash, !param ? 0 : 1);
        //合约发布所需参数
        var arr = [
          this.tokenForm.decimals,
          this.tokenForm.total,
          this.tokenForm.maxWalletAmount,
          this.tokenForm.buyFundFee,
          this.tokenForm.buyLPFee,
          this.tokenForm.buyReflectFee,
          this.tokenForm.buyBurnFee,
          this.tokenForm.sellFundFee,
          this.tokenForm.sellLPFee,
          this.tokenForm.sellReflectFee,
          this.tokenForm.sellBurnFee,
          this.tokenForm.kb,
          this.tokenForm.airdropNumbs,
        ];
        arr.forEach((element, index) => {
          if (element == null) {
            arr[index] = 0;
          }
          if (index >= 3 && index <= 10) {
            arr[index] = arr[index] * 100;
          }
        });
        var temp = this.tokenForm.currency;
        if(temp == "default" && this.tokenForm.currencyAddress){
          temp = this.tokenForm.currencyAddress;
        }
        this.deployData = [
          [this.tokenForm.name, this.tokenForm.symbol],
          [
            this.tokenForm.fundAddress,
            temp,
            this.tokenForm.swapPlatform,
            this.account,
            this.tokenForm.rewordToken,
          ],
          arr,
          [
            this.tokenForm.enable0ffTrade,
            this.tokenForm.enableKillBlock,
            this.tokenForm.enableRewardList,
            this.tokenForm.enableWalletLimit,
            this.tokenForm.enableChangeTax,
            this.tokenForm.currencyIsEth,
            this.tokenForm.airdropEnable,
          ],
        ];
        //显示发布合约弹窗
        this.showDeploy = true;
      } else {
        this.$message({
          message: "请求失败",
          type: "warning",
        });
      }
      this.showLoading = false;
    },
    async saveRecord(hash, type) {
      var data = {
        contractAddress: this.contractData.contractAddr,
        name: this.tokenForm.name,
        symbol: this.tokenForm.symbol,
        template: this.contractData.contractCode,
        owner: this.account,
        chainId: localStorage.getItem("TokenBox-chainID"),
        hash: hash,
        content: JSON.stringify(this.tokenForm),
      };
      if (type == 1) {
        //更新发布记录
        data.contractId = parseInt(this.contractData.contractId);
        updateContractRecord(JSON.stringify(data));
      } else {
        //保存发布记录
        var saveRes = await saveContractRecord(JSON.stringify(data));
        if (saveRes && saveRes.data.contractId) {
          this.contractData.contractId = saveRes.data.contractId;
        }
      }
    },
    // 设置营销地址
    setfundAddress() {
      if (localStorage.getItem("TokenBox-account")) {
        this.tokenForm.fundAddress = localStorage.getItem("TokenBox-account");
      }
    },
    onlyNumber() {
      this.tokenForm.buyFundFee = this.onlyNumOnePoint(
        this.tokenForm.buyFundFee
      );
      this.tokenForm.buyBurnFee = this.onlyNumOnePoint(
        this.tokenForm.buyBurnFee
      );
      this.tokenForm.buyReflectFee = this.onlyNumOnePoint(
        this.tokenForm.buyReflectFee
      );
      this.tokenForm.buyLPFee = this.onlyNumOnePoint(this.tokenForm.buyLPFee);

      this.tokenForm.sellFundFee = this.onlyNumOnePoint(
        this.tokenForm.sellFundFee
      );
      this.tokenForm.sellBurnFee = this.onlyNumOnePoint(
        this.tokenForm.sellBurnFee
      );
      this.tokenForm.sellReflectFee = this.onlyNumOnePoint(
        this.tokenForm.sellReflectFee
      );
      this.tokenForm.sellLPFee = this.onlyNumOnePoint(this.tokenForm.sellLPFee);
    },
    onlyNumOnePoint(number_only) {
      if (number_only == null) {
        return null;
      }
      //先把非数字的都替换掉，除了数字和小数点
      number_only = number_only.replace(/[^\d.]/g, "");
      //必须保证第一个为数字而不是小数点
      number_only = number_only.replace(/^\./g, "");
      //保证只有出现一个小数点而没有多个小数点
      number_only = number_only.replace(/\.{2,}/g, ".");
      //保证小数点只出现一次，而不能出现两次以上
      number_only = number_only
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      //保证只能输入两个小数
      number_only = number_only.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
      return number_only;
    },
  },
  computed: {
    buyTaxRate() {
      var buyFundFee = isNaN(parseFloat(this.tokenForm.buyFundFee))
        ? 0
        : parseFloat(this.tokenForm.buyFundFee);
      var buyBurnFee = isNaN(parseFloat(this.tokenForm.buyBurnFee))
        ? 0
        : parseFloat(this.tokenForm.buyBurnFee);

      var buyReflectFee = isNaN(parseFloat(this.tokenForm.buyReflectFee))
        ? 0
        : parseFloat(this.tokenForm.buyReflectFee);

      var buyLPFee = isNaN(parseFloat(this.tokenForm.buyLPFee))
        ? 0
        : parseFloat(this.tokenForm.buyLPFee);

      this.tokenForm.buyResult =
        buyFundFee + buyBurnFee + buyReflectFee + buyLPFee;

      if (this.tokenForm.buyResult > 25) {
        this.$message({
          message: "百分比设置,总比例不可以大于百分之25%",
          type: "warning",
        });
      }
      return this.tokenForm.buyResult;
    },
    sellTaxRate() {
      var sellFundFee = isNaN(parseFloat(this.tokenForm.sellFundFee))
        ? 0
        : parseFloat(this.tokenForm.sellFundFee);
      var sellBurnFee = isNaN(parseFloat(this.tokenForm.sellBurnFee))
        ? 0
        : parseFloat(this.tokenForm.sellBurnFee);

      var sellReflectFee = isNaN(parseFloat(this.tokenForm.sellReflectFee))
        ? 0
        : parseFloat(this.tokenForm.sellReflectFee);

      var sellLPFee = isNaN(parseFloat(this.tokenForm.sellLPFee))
        ? 0
        : parseFloat(this.tokenForm.sellLPFee);

      this.tokenForm.sellResult =
        sellFundFee + sellBurnFee + sellReflectFee + sellLPFee;
      if (this.tokenForm.sellResult > 25) {
        this.$message({
          message: "百分比设置,总比例不可以大于百分之25%",
          type: "warning",
        });
      }
      return this.tokenForm.sellResult;
    },
  },
};
</script>

<style lang="scss" scoped>
.token-body {
  width: calc(100% - 30%);
  height: 100%;
  background: #1f1f1f;
  border-radius: 20px 20px 20px 20px;

  padding: 0 15% 0 15%;

  .token-form {
    width: 100%;
    margin: 20px 0 0 0;

    .token-title {
      font-weight: normal;
      font-size: 20px;
      color: #8f8f8f;
      line-height: 23px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin: 4% 0 0 0;
    }

    .token-advantages {
      font-weight: normal;
      font-size: 12px;
      color: #8f8f8f;
      line-height: 14px;
      text-align: center;
      font-style: normal;
      text-transform: none;

      margin: 18px 0 0 0;

      span {
        margin: 0 10px 0 10px;
      }
    }

    /deep/.el-input__inner {
      height: 46px;

      background: #292929;
      border-radius: 4px 4px 4px 4px;
      border: none;

      font-weight: normal;
      font-size: 14px;
      color: #ffffff;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    /deep/.el-textarea__inner {
      background: #292929;
      border-radius: 4px 4px 4px 4px;
      border: none;

      font-weight: normal;
      font-size: 14px;
      color: #ffffff;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
    /deep/.el-input__count {
      background: #292929;
      border-radius: 4px 4px 4px 4px;
      border: none;

      font-weight: normal;
      font-size: 14px;
      color: #ffffff;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    /deep/.el-form-item__label {
      font-weight: normal;
      font-size: 14px;
      color: #c4c2c2;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    /deep/.el-input-number__decrease {
      width: 58px;
      height: 44px;
      background: #444170;
      border-radius: 4px 0px 0px 4px;
      border: 1px solid #7d77c0;
      display: flex;
      justify-content: center;
      align-items: center;

      .el-icon-minus {
        font-size: 24px;
        color: #d9d9d9;
      }
    }
    /deep/.el-input-number__decrease:hover {
      border: 1px solid #aba4ff;
    }

    /deep/.el-input-number__increase {
      width: 58px;
      height: 44px;
      background: #444170;
      border-radius: 0px 4px 4px 0px;
      border: 1px solid #7d77c0;
      display: flex;
      justify-content: center;
      align-items: center;

      .el-icon-plus {
        font-size: 24px;
        color: #cdc9ff;
      }
    }
    /deep/.el-input-number__increase:hover {
      border: 1px solid #aba4ff;
    }
    /deep/.el-input-number {
      width: 332px;
    }
    .token-inputNumber {
      /deep/.el-input__inner {
        text-align: center;
      }
    }

    /deep/.el-switch__core {
      width: 80px !important;
      height: 36px;
      background: #161616;
      border-radius: 30px 30px 30px 30px;
      border: 1px solid #3b3b3b;
    }
    /deep/.el-switch__core::after {
      width: 28px;
      height: 28px;
      background: #999999;
      border-radius: 30px 30px 30px 30px;
      margin: 2px 2px 2px 2px;
    }
    /deep/.el-switch.is-checked .el-switch__core::after {
      left: calc(100% - 34px);
      background: #675aff;
    }

    .token-mark {
      font-weight: normal;
      font-size: 12px;
      color: #6e6e6e;
      line-height: 14px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      padding: 0 0 0 12px;
    }

    /deep/.el-input-group__append {
      background: #3d3d3d;
      border-radius: 0px 4px 4px 0px;
      border: none;

      font-weight: normal;
      font-size: 16px;
      color: #939393;
      line-height: 19px;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }

    /deep/.el-select-dropdown {
      width: 198px;
      // background: #d9d9d9;
      border-radius: 8px 8px 8px 8px;
      font-weight: 400;
      font-size: 14px;
      color: #8f8f8f;
      line-height: 16px;
      text-align: center;
      font-style: normal;
      text-transform: none;

      top: 65px !important;
    }

    /deep/.el-select-dropdown__item:hover {
      background: rgba(77, 77, 77, 0.5);
      color: #d8d8d8;
    }

    /deep/.el-select-dropdown__item.selected {
      color: #675aff;
    }

    /deep/.popper__arrow {
      left: 93px !important;
    }

    .token-handlingFees {
      display: flex;
      align-items: center;
      margin: 0 0 20px 0;

      /deep/.el-input-group__prepend {
        display: table-row;
        font-weight: normal;
        font-size: 14px;
        color: #8f8f8f;
        line-height: 2.7em;
        text-align: left;
        font-style: normal;
        text-transform: none;
        background: transparent;
        border: none;
        padding: 0 20px 0 0;
      }
    }

    /deep/.el-radio {
      font-weight: normal;
      font-size: 14px;
      color: #d8d8d8;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
    /deep/.el-radio.is-bordered {
      background: #292929;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #3b3b3b;
    }
    /deep/.el-radio.is-bordered.is-checked {
      border: 1px solid #675aff;
    }
    /deep/.el-radio__input.is-checked + .el-radio__label {
      color: #675aff;
    }
    /deep/.el-radio__input.is-checked .el-radio__inner {
      color: #675aff;
      background: #675aff;
    }

    .token-optionalContent {
      span {
        font-weight: normal;
        font-size: 14px;
        color: #ffffff;
        line-height: 16px;
        text-align: left;
        font-style: normal;
        text-transform: none;

        margin: 0 0 0 12px;
        cursor: pointer;
      }
    }

    .token-cost {
      font-weight: normal;
      font-size: 12px;
      color: #ffffff;
      line-height: 14px;
      text-align: center;
      font-style: normal;
      text-transform: none;

      margin: 60px 0 0 0;
    }

    .token-createBtn {
      width: 228px;
      height: 46px;
      background: #4438d4;
      border-radius: 30px 30px 30px 30px;
      border: 1px solid #695cff;

      font-weight: normal;
      font-size: 14px;
      color: #ffffff;
      line-height: 46px;
      text-align: center;
      font-style: normal;
      text-transform: none;

      margin: 0 auto 0 auto;
      cursor: pointer;
    }

    .token-createBtn:hover {
      border: 1px solid #aba4ff;
    }

    .token-alert {
      font-weight: 700;
      font-size: 14px;
      color: #ffffff;
      line-height: 46px;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }

    .token-alert2 {
      font-weight: 700;
      font-size: 14px;
      color: #ffffff;
      line-height: 46px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
  }

  .form-labelHorizontal {
    display: flex;
    align-items: center;

    /deep/.el-form-item__label {
      padding: 0 12px 0 0;
    }
  }
}
</style>